<template>
    <div class="container">
        <b-modal
            :model-value="EditNiifNoContr"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
         @hide="closeModal">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.vigencia }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="selVigencia"
                            class="form-input"
                            :disabled="isVigenciaBloqueada"
                        >
                            <option 
                                v-for="vigencia in listVigencia" 
                                :key="vigencia?.vigencia" 
                                :value="vigencia?.vigencia"
                            >
                                {{ vigencia?.vigencia }}
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.niif }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="selNiif"
                            class="form-input"
                            :disabled="isVigenciaBloqueada"
                        >
                            <option value="" disabled>Seleccione un NIIF</option>
                            <option 
                                v-for="niif in listaNiif" 
                                :key="niif?.id" 
                                :value="niif?.niif"
                            >
                                {{ niif?.niif }}
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeModal">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="guardaNiif" :disabled="isVigenciaBloqueada">{{ labels.save }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import NiifNoControlante from '../../services/NiifNoControlante';
import PlanConsolidacion from '../../services/PlanConsolidacion';

export default {
    name: "EditaNiifNoControlante",
    props: ['EditNiifNoContr', 'regNiif'],
    data: () => ({
        listVigencia: [],
        selVigencia: "",
        listaNiif: [],
        selNiif: "",
        selVigenciaAnterior: ""
    }),
    computed: {
        isVigenciaBloqueada() {
            return this.selVigencia ? !this.$store.getters.isPeriodoEnabled(this.selVigencia) : false
        },
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar NIIF",
                    vigencia: "Vigencia",
                    niif: "NIIF",
                    save: "Guardar",
                    close: "Cerrar",
                    infoTitle: "Datos del NIIF",
                    infoText: "Actualiza la información y guarda los cambios."
                }
            } else {
                return {
                    title: "Edit NIIF",
                    vigencia: "Validity",
                    niif: "NIIF",
                    save: "Save",
                    close: "Close",
                    infoTitle: "NIIF information",
                    infoText: "Update the information and save changes."
                }
            }
        }
    },
    methods: {
        guardaNiif() {
            if (this.isVigenciaBloqueada) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar')
                return
            }
            if (this.selNiif == "") {
                this.$toast.error('Seleccionar un NIIF')
                return
            }

            let infoData = {
                "niif": this.selNiif,
                "idNiif": this.regNiif,
                "idUser": this.$store.state.userId
            }

            NiifNoControlante.updateNiifNoControlante(infoData)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.$emit('reload')
                    this.closeModal()
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error('Error al actualizar el NIIF')
                })
        },
        closeModal() {
            this.selVigencia = ""
            this.selNiif = ""
            this.$emit('closeModal', false)
        },
        cargarNiifPorVigencia() {
            if (!this.selVigencia) return

            PlanConsolidacion.getPlanConsPorCompVige(this.selVigencia)
                .then((res) => {
                    this.listaNiif = res.data.planConsNiif || []
                })
                .catch((err) => {
                    console.log(err)
                    this.listaNiif = []
                })
        }
    },
    mounted() {
        PlanConsolidacion.getVigenciaPlanCons()
            .then((res) => {
                this.listVigencia = res.data.getVigencia || []
                if (this.listVigencia.length > 0) {
                    this.selVigencia = this.listVigencia[0].vigencia
                }
            })
            .catch((err) => console.log(err))
    },
    watch: {
        selVigencia(valNew) {
            if (valNew !== this.selVigenciaAnterior) {
                this.selVigenciaAnterior = valNew
                if (this.isVigenciaBloqueada) {
                    this.listaNiif = []
                    this.selNiif = ""
                    this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar')
                    return
                }
                this.cargarNiifPorVigencia()
            }
        },
        EditNiifNoContr(valNew) {
            if (valNew) {
                if (this.selVigencia) {
                    this.cargarNiifPorVigencia()
                }
            }
        }
    }
}
</script>